/**
 * Date display and HTML date input helpers for list/detail UIs.
 */

import dayjs from "dayjs";

/**
 * Created/completed (and similar) timestamps: one consistent local `MM/DD/YYYY h:mm A`.
 * Do not use for task `due_date` — use `formatDueDate` / `formatDueDateTimeForTable` from `dueDateTime.js`.
 */
export function formatTimestampForTable(value) {
  if (value == null || value === "") return "—";
  const d = dayjs(value);
  return d.isValid() ? d.format("MM/DD/YYYY h:mm A") : "—";
}

/**
 * Date-only for compact table columns (`MM/DD/YYYY`). Use when time would waste horizontal space.
 * Prefer {@link formatTimestampForTable} in tooltips / detail panels when time still matters.
 */
export function formatTimestampDateForTable(value) {
  if (value == null || value === "") return "—";
  const d = dayjs(value);
  return d.isValid() ? d.format("MM/DD/YYYY") : "—";
}

export function formatDateCell(dateLike) {
  if (!dateLike) return "—";
  const d = new Date(dateLike);
  if (Number.isNaN(d.getTime())) return "—";
  return d.toLocaleDateString();
}

/** Local calendar day for `<input type="date">` (matches legacy FinancialAccounts behavior). */
export function toDateInputValueLocalCalendar(dateLike) {
  if (!dateLike) return "";
  const d = new Date(dateLike);
  if (Number.isNaN(d.getTime())) return "";
  const tzOffset = d.getTimezoneOffset() * 60000;
  return new Date(d.getTime() - tzOffset).toISOString().slice(0, 10);
}

/** Stored Date → YYYY-MM-DD via UTC slice (matches legacy Transaction detail behavior). */
export function toDateInputValueUtcSlice(dateLike) {
  if (!dateLike) return "";
  const d = new Date(dateLike);
  if (Number.isNaN(d.getTime())) return "";
  return d.toISOString().slice(0, 10);
}
